import { lazy, Suspense } from 'react';
import { PageSkeleton } from '@/components/ui';

/**
 * Devportal: leichtgewichtiger Mount-Wrapper (Spec 247 §4.4/AC-1).
 *
 * NUR dieser Wrapper geht durch den Pages-Barrel in App.tsx — das eigentliche
 * Modul (Router, Layout, Seiten, spaeter Scalar) laedt per React.lazy in
 * einen eigenen Chunk. Bei Flag aus wird die Route nie registriert, der
 * Chunk nie angefordert (AC-1: kein Devportal-Code im Initial-Load).
 */
const DevportalModule = lazy(() => import('./module'));

export function DevportalRoutes() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DevportalModule />
    </Suspense>
  );
}
